export enum POSEndpoints {
  terminal = "terminals",
  documentPrintCopy = "configuration-copy",
  menuProduct = "menu-products",
  menuProductDetail = "menu-product-details",
  printer= "printers",
}

export enum MaintenanceEndpoints {
  fingerReason = "finger-reasons",
  supervisorPermission = "supervisor-permissions",
  userAH = "user-ahs",
  specialAccessUser = "special-access-users",
  reasonBlocked = "member-club-reason-blocked",
}

export enum DualPaymentsAdminEndpoints {
  company = "dualpayments-admin/companies",
}

export enum GeneralEndpoints {
  currency = "currencies",
  vendorPostingGroup = "vendor-posting-groups",
  serie = "series",
  serieDetail = "serie-details",
  module = "modules",
  serieSetup = "serie-setups",
  cashDeclaration = "cash-declarations",
  configuration = "configurations",
  configurationComision = "comision-configurations",
  infoCode = "info-codes",
}

export enum EmployeesEndpoints {
  employeeType = "employee-types",
}

export enum AccountingEndpoints {
  documentFiscalTypes = "documentFiscalTypes",
  accountMovement = "accountMovement",
  accountExpenses = "accounting/expenses",
  accountManualSeat = "accountingManualSeats",
  accountMovementPayment = "accountMovementPayment",
  accountMovementQuotation = "accountMovementQuotation",
  creditNotes = "credit-notes",
  journal = "accounting-journals",
  journalPaymentType = "accounting-journals-paymentType",
}

export enum ProductsEndpoints {
  vendor = "vendors",
  product = "products",
  purchaseRequest = "purchaseRequest",
  requisition = "requisition",
  quotation = "quotation",
  purchaseRequestDetail = "purchaseRequest-details",
  purchaseReceipt = "purchaseReceipt",
  warehouseTransfer = "warehouseTransfer",
  importCost = "import-costs",
  billLading = "billLadings",
}

export enum PricesEndpoints {
  paymentMethodGroup = "payment-method-groups",
  giftCard = "gift-cards",
  voucher = "vouchers",
  voucherType = "voucher-type",
  voucherTypeMethod = "voucher-type-method",
  bank = "banks",
  bankAccount = "bankAccounts",
  vendorBankAccount = "vendorBankAccounts",
  bankDeposit = "bankDeposits",
  termBC = "terms-bc",
}

export enum StoresEndpoints {
  accountSubcategory = "account-subcategories",
  incomeExpenseAccount = "income-expense-accounts",
  ledgerAccount = "ledger-accounts",
  paymentMethodXStore = "payment-methods-stores",
  configurationXStore = "configuration-stores",
  msrXEmployee = "msr-employees",
  fingerPrintXEmployee = "finger-prints-employees",
  sale = "sales",
  transactionType = "transaction-type",
  company = "companies",
  companyType = "companyTypes",
  salestatus = "sale-status",
  serviceCategory = "service-category",
}

export enum OffersEndpoints {
  coupon = "coupons",
  couponDetail = "coupon-details",
  couponIssuer = "coupon-issuers",
}
export enum FormatEndpoints {
  format = "docFormats",
  formatDetail = "format-sections",
}
export enum CustomersEndpoints {
  memberClubScheme = "member-club-schemas",
  memberClubCardSpool = "member-club-card-spools",
}

export enum OfferOnDiscountEndpoints {
  offerOnDiscountConfig = "offers-on-discount-configs",
}

export enum ReturnReasonsEndpoints {
  returnReason = "return-reasons",
  printReason = "print-reasons",
}

export enum StorageEndpoints {
  storage = "uploads",
}
